<template>
    <div>
        <slot />
    </div>
</template>
 
<script>
export default {
    name: 'Error',
};
</script>

<style scoped>
#main {
    height: 100vh;
    background-color: white;
}
</style>
